import React from 'react';
import { Attributes } from '@leverege/ui-attributes';
import { ModelFactory } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import HistoryRenderer from "../../dataViewers/map/googleMap/renderers/HistoryRenderer.js";
import { HistoryLoadDataRenderer } from "../../dataViewers/map/mapbox/renderers/index.js";
import HistoryModel from "../../dataViewers/map/shared/renderers/HistoryModel.js";
import HeatmapRenderer from "../../dataViewers/map/googleMap/renderers/HeatmapRenderer.js";
import HeatmapModel from "../../dataViewers/map/googleMap/renderers/HeatmapModel.js";
const {
  t
} = I18N.ns('molten.imagine.map.GoogleMapsHistoryRendererCreator');
function processRelationship(molten, relationship, options) {
  const {
    attribute,
    blueprint,
    path
  } = relationship;
  const gpAttr = Attributes.getAttribute('geoPosition', blueprint.historyType);
  const historyLayerName = blueprint.historyType;
  const heatmapLayerName = `${blueprint.historyType}.heatmap`;
  if (attribute == null && gpAttr) {
    molten.addPlugin('GoogleMapsRenderer', {
      id: `blueprint.${blueprint.type}.geoPosition.HistoryRenderer`,
      matches: {
        client: 'GoogleMapsDataViewer',
        objectType: blueprint.type,
        isItem: true
      },
      layerName: historyLayerName,
      sort: 'bbb',
      createModel(lastModel) {
        if (lastModel == null || lastModel.objectType !== blueprint.historyType) {
          return HistoryModel.create(historyLayerName, t('historyLayerName', {
            blueprintName: blueprint.namePlural,
            attributeName: gpAttr.displayName
          }), blueprint.historyType);
        }
        return lastModel;
      },
      create: props => {
        if (props.model?.visible === false) {
          return null;
        }
        return /*#__PURE__*/React.createElement(HistoryLoadDataRenderer, {
          ...props,
          renderer: HistoryRenderer,
          key: `${path}.history`,
          attributeName: gpAttr.name,
          Model: HistoryModel
        });
      }
    });
    molten.addPlugin('GoogleMapsRenderer', {
      id: `blueprint.${blueprint.type}.geoPosition.HistoryHeatmapRenderer`,
      matches: {
        client: 'GoogleMapsDataViewer',
        objectType: blueprint.type,
        isItem: true
      },
      layerName: heatmapLayerName,
      sort: 'bbb',
      createModel(lastModel) {
        if (lastModel == null || lastModel.objectType !== blueprint.historyType) {
          return HeatmapModel.create(heatmapLayerName, t('heatmapLayerName', {
            blueprintName: blueprint.namePlural,
            attributeName: gpAttr.displayName
          }), blueprint.historyType);
        }
        return lastModel;
      },
      create: props => {
        if (props.model?.visible === false) {
          return null;
        }
        return /*#__PURE__*/React.createElement(HistoryLoadDataRenderer, {
          ...props,
          renderer: HeatmapRenderer,
          key: `${path}.history.heatmap`,
          attributeName: gpAttr.name,
          Model: HeatmapModel
        });
      }
    });
  }
  if (attribute == null) {
    const positions = Attributes.getAttributesFor(blueprint.historyType).filter(attr => {
      return attr?.blueprint?.attribute?.type === 'geoPoint' && (!gpAttr || attr?.source?.field !== gpAttr?.source?.field);
    });
    const addedLayers = {};
    positions.forEach(uiAttr => {
      const attr = uiAttr.source.attribute;
      if (addedLayers[attr.path]) {
        return;
      }
      addedLayers[attr.path] = true;
      const path = attr.path.replace(/\//g, '.');
      const layerName = `${blueprint.historyType}.${path}`;
      molten.addPlugin('GoogleMapsRenderer', {
        id: `blueprint.${blueprint.type}.${uiAttr.name}.HistoryRenderer`,
        matches: {
          client: 'GoogleMapsDataViewer',
          objectType: blueprint.type,
          isItem: true
        },
        layerName,
        sort: `bbb.${attr.name}`,
        createModel(lastModel) {
          let modelClzz;
          const layerRendererType = blueprint.getTagStartingWith('historyLayerRenderer', true);
          if (layerRendererType) {
            modelClzz = ModelFactory.get(layerRendererType);
          }
          if (!modelClzz) {
            modelClzz = HistoryModel;
          }
          if (lastModel == null || lastModel.objectType !== blueprint.historyType) {
            return modelClzz.create(layerName, t('historyLayerName', {
              blueprintName: blueprint.namePlural,
              attributeName: uiAttr.displayName
            }), blueprint.historyType);
          }
          return lastModel;
        },
        create: props => {
          return /*#__PURE__*/React.createElement(HistoryLoadDataRenderer, {
            ...props,
            renderer: HistoryRenderer,
            key: `${path}.history`,
            attributeName: uiAttr.name,
            Model: HistoryModel
          });
        }
      });
    });
  }
}
export default {
  id: 'molten.BlueprintGoogleMapsHistoryRendererCreator',
  processRelationship
};